import { render } from "./TerminateInfoModal.vue?vue&type=template&id=2ca1d506&scoped=true&ts=true"
import script from "./TerminateInfoModal.vue?vue&type=script&lang=ts"
export * from "./TerminateInfoModal.vue?vue&type=script&lang=ts"

import "./TerminateInfoModal.vue?vue&type=style&index=0&id=2ca1d506&scoped=true&lang=css"

import exportComponent from "/Users/neiloswald/Workspace/ionic/mtzoom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca1d506"]])

export default __exports__